import {IOrderRes} from '~/shared/services/bffService/api/interfaces/responses';

import {makeAsyncReducer, StateAsyncProperty} from '../../redux-toolbelt';

import {fetchOrderSummaryIfNeeded} from './orderSummaryActions';

export type OrderSummaryState = StateAsyncProperty<Omit<IOrderRes, 'dishes'> & {dishToPresent: IOrderRes['dishes']}>;

export default makeAsyncReducer<OrderSummaryState>(fetchOrderSummaryIfNeeded);
